module.exports = __webpack_public_path__ + "static/taylor-3936a28c38b96fe1b48336ff694a6dfc.png";